const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    minHeight: '87px',
  },
};

export default style;
